// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"ZF-z","paperCuts":"_F-z"};